"use client"

import { useLocale } from "@/lib/locale-context"
import { Reveal } from "@/components/reveal"
import { SectionHead } from "@/components/section-head"

export function SectionFocus() {
  const { t } = useLocale()

  return (
    <section id="focus" className="shell scroll-mt-16 py-12 md:py-20" aria-labelledby="focus-heading">
      <SectionHead id="focus" index="02" title={t.focus.title} lead={t.focus.lead} />

      <div className="mt-8 grid grid-cols-1 gap-x-8 md:mt-12 md:grid-cols-2">
        {t.focus.items.map((item, i) => (
          <Reveal key={item.label} className="row-mark border-t border-border py-6">
            <span className="reveal t-small tabular-nums text-accent">{`0${i + 1}`}</span>
            <h3 className="reveal t-md mt-2 text-balance text-foreground">{item.label}</h3>
            <p
              className="reveal t-body mt-3 max-w-[46ch] text-muted-foreground"
              style={{ ["--d" as string]: "90ms" }}
            >
              {item.detail}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
